module.exports = __webpack_public_path__ + "static/media/Residential_45.312ac744.jpg";